import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=27fdeaa8&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style1 from "./Detail.vue?vue&type=style&index=1&id=27fdeaa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdeaa8",
  null
  
)

export default component.exports